import I18n from '~/i18n';

export const lookupLanguages = {
  'pt-BR': I18n.t('language-ptBR'),
  'en': I18n.t('language-en'),
  'es': I18n.t('language-es'),
};

export const lookupCurrencies = {
  'R$': I18n.t('currency-brl'),
  'US$': I18n.t('currency-usd'),
  '€': I18n.t('currency-eur'),
  '$': I18n.t('currency-ars'),
};

export const languages = Object.keys(lookupLanguages).map(id => ({
  id,
  name: lookupLanguages[id],
}));

export const currencies = Object.keys(lookupCurrencies).map(id => ({
  id,
  name: lookupCurrencies[id],
}));
